import { useState } from "react";
import { useEffect } from "react";
import { BuscaCEP } from "../../../../Services/Tools/ViaCep";
import { useFormContext } from "react-hook-form";

import { ValidationErr } from "../../../../Validations/ValidationError";
import { IEstado } from "../../../../Interfaces/Geral/Endereco/Estado/EstadoInterfaces";
import { ICidade } from "../../../../Interfaces/Geral/Endereco/Cidade/CidadeInterfaces";
import {
    GetCidadeController,
    GetCidadePorIdController,
    ListarCidadesController,
} from "../../../../Controllers/Geral/Endereco/Cidade/CidadeControllers";
import { ListarEstadosController } from "../../../../Controllers/Geral/Endereco/Estado/EstadoControllers";

interface IInformacoesEndereco {
    ID_CIDADE_ENDERECO?: number;
    ID_ESTADO_ENDERECO?: number;
    DS_BAIRRO_ENDERECO?: string;
    DS_LOGRADOURO_ENDERECO?: string;
    NR_ENDERECO_ENDERECO?: string;
    DS_COMPLEMENTO_COBRANCA?: string;
    DS_COMPLEMENTO_ENDERECO?: string;
    NR_CEP_ENDERECO?: number;
}
interface IInformcaoEnderecoForm {
    INFO_END: Array<{
        ID_CIDADE_ENDERECO?: number;
        ID_ESTADO_ENDERECO?: number;
        DS_BAIRRO_ENDERECO?: string;
        DS_LOGRADOURO_ENDERECO?: string;
        NR_ENDERECO_ENDERECO?: number;
        DS_COMPLEMENTO_ENDERECO?: string;
        NR_CEP_ENDERECO?: number;
    }>;
}
interface PropsComponents {
    ObjectInformacoesEndereco: IInformacoesEndereco;
    title?: string;
    formIndex?: number;
}
interface IEstadoComCidade extends IEstado {
    cidades?: Array<ICidade>;
}

export default function InformacoesEnderecoCard(props: PropsComponents) {
    const { register, getValues, setValue } =
        useFormContext<IInformcaoEnderecoForm>();

    const [cidadeID, setCidadeID] = useState<number>();
    const [estadoID, setEstadoID] = useState<number>();

    const [lstEstados, setLstEstados] = useState<Array<IEstadoComCidade>>([]);
    const [lstCidades, setLstCidades] = useState<Array<ICidade>>();

    const index = props.formIndex ?? 0;

    useEffect(() => {
        ListarEstadosController().then((res) => {
            setLstEstados(res);
            if (props.ObjectInformacoesEndereco?.ID_CIDADE_ENDERECO) {
                GetCidadePorIdController(
                    props.ObjectInformacoesEndereco.ID_CIDADE_ENDERECO
                ).then((res) => {
                    setCidadeID(res.ID_CIDADE);
                    setEstadoID(res.ID_ESTADO);
                });
            }
        });
        if (props.ObjectInformacoesEndereco?.ID_CIDADE_ENDERECO) {
            Promise.all([
                ListarEstadosController(),
                GetCidadePorIdController(
                    props.ObjectInformacoesEndereco.ID_CIDADE_ENDERECO
                ),
            ]).then(async ([estados, cidade]) => {
                setLstEstados(estados);
            });
        }
    }, [props.ObjectInformacoesEndereco?.ID_CIDADE_ENDERECO, index]);

    useEffect(() => {
        if (cidadeID && estadoID && lstEstados) {
            setValue(`INFO_END.${index}.ID_ESTADO_ENDERECO`, estadoID);
            updateCidadesSelect(estadoID, lstEstados).then(() => {
                setValue(`INFO_END.${index}.ID_CIDADE_ENDERECO`, cidadeID);
            });
        }
    }, [cidadeID, lstEstados, estadoID, index, setValue]);

    async function updateCidadesSelect(
        id_estado?: number,
        lstEstados?: Array<IEstadoComCidade>
    ) {
        const estado = lstEstados?.find(
            (estado) => estado.ID_ESTADO === id_estado
        );
        if (estado && id_estado) {
            if (!estado.cidades) {
                estado.cidades = await ListarCidadesController(id_estado);
            }
            setLstCidades(estado.cidades || []);
        } else setLstCidades([]);
    }

    return (
        <>
            <div className="form-group">
                <div data-scroll="true" data-height="200">
                    <div className="row flex-wrap align-self-stretch justify-content-start">
                        <div className="input-icon input-icon-right p-2 col-12 col-sm-6 col-md-3">
                            <label
                                htmlFor={`INFO_END.${index}.NR_CEP_ENDERECO`}
                            >
                                CEP
                            </label>
                            <input
                                type="text"
                                id={`INFO_END.${index}.NR_CEP_ENDERECO`}
                                name={`INFO_END.${index}.NR_CEP_ENDERECO`}
                                className="form-control"
                                placeholder="CEP"
                                defaultValue={
                                    props.ObjectInformacoesEndereco
                                        ?.NR_CEP_ENDERECO
                                }
                                ref={register()}
                            />
                            <span
                                className="pt-7 pr-5"
                                onClick={async () => {
                                    await BuscaCEP(
                                        Number.parseInt(
                                            `${getValues(
                                                `INFO_END.${index}.NR_CEP_ENDERECO`
                                            )}`?.replace(/([^\d])+/gim, "") ||
                                                "0"
                                        )
                                    )
                                        .then((InformCep) => {
                                            GetCidadeController(
                                                InformCep.localidade
                                            ).then((cidade) => {
                                                setValue(
                                                    `INFO_END.${index}.ID_ESTADO_ENDERECO`,
                                                    cidade.ID_ESTADO
                                                );
                                                updateCidadesSelect(
                                                    cidade.ID_ESTADO,
                                                    lstEstados
                                                ).then(() => {
                                                    setValue(
                                                        `INFO_END.${index}.ID_CIDADE_ENDERECO`,
                                                        cidade.ID_CIDADE
                                                    );
                                                });
                                            });
                                            setValue(
                                                `INFO_END.${index}.DS_BAIRRO_ENDERECO`,
                                                InformCep.bairro
                                            );
                                            setValue(
                                                `INFO_END.${index}.DS_LOGRADOURO_ENDERECO`,
                                                InformCep.logradouro
                                            );
                                        })
                                        .catch(ValidationErr);
                                }}
                            >
                                <i className="flaticon2-search-1 icon-md"></i>
                            </span>
                        </div>
                        <div className="input-icon input-icon-right p-2 col-12 col-sm-6 col-md-3">
                            <label
                                htmlFor={`INFO_END.${index}.ID_ESTADO_ENDERECO`}
                            >
                                Estado
                            </label>
                            <select
                                className="form-control"
                                id={`INFO_END.${index}.ID_ESTADO_ENDERECO`}
                                name={`INFO_END.${index}.ID_ESTADO_ENDERECO`}
                                data-live-search="true"
                                defaultValue={
                                    props.ObjectInformacoesEndereco
                                        ?.ID_ESTADO_ENDERECO || 0
                                }
                                onChange={async (e) => {
                                    const id_estado = Number.parseInt(
                                        e.target.value
                                    );
                                    updateCidadesSelect(id_estado, lstEstados);
                                }}
                                ref={register()}
                            >
                                <option></option>
                                {lstEstados.map((estado) => (
                                    <option
                                        value={estado.ID_ESTADO}
                                        key={estado.ID_ESTADO}
                                    >
                                        {estado.DS_ESTADO}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="input-icon input-icon-right p-2 col-12 col-sm-6 col-md-3">
                            <label
                                htmlFor={`INFO_END.${index}.ID_CIDADE_ENDERECO`}
                            >
                                Cidade
                            </label>
                            <select
                                className="form-control"
                                id={`INFO_END.${index}.ID_CIDADE_ENDERECO`}
                                name={`INFO_END.${index}.ID_CIDADE_ENDERECO`}
                                data-live-search="true"
                                defaultValue={
                                    props.ObjectInformacoesEndereco
                                        ?.ID_CIDADE_ENDERECO || 0
                                }
                                ref={register()}
                            >
                                <option></option>
                                {lstCidades?.map((cidade) => (
                                    <option
                                        value={cidade.ID_CIDADE}
                                        key={cidade.ID_CIDADE}
                                    >
                                        {cidade.DS_CIDADE}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="input-icon input-icon-right p-2 col-12 col-sm-6 col-md-3">
                            <label
                                htmlFor={`INFO_END.${index}.DS_BAIRRO_ENDERECO`}
                            >
                                Bairro
                            </label>
                            <input
                                type="text"
                                id={`INFO_END.${index}.DS_BAIRRO_ENDERECO`}
                                name={`INFO_END.${index}.DS_BAIRRO_ENDERECO`}
                                className="form-control"
                                placeholder="Bairro"
                                defaultValue={
                                    props.ObjectInformacoesEndereco
                                        ?.DS_BAIRRO_ENDERECO
                                }
                                ref={register()}
                            />
                        </div>
                        <div className="input-icon input-icon-right p-2 col-12 col-sm-6">
                            <label
                                htmlFor={`INFO_END.${index}.DS_LOGRADOURO_ENDERECO`}
                            >
                                Rua
                            </label>
                            <input
                                type="text"
                                id={`INFO_END.${index}.DS_LOGRADOURO_ENDERECO`}
                                name={`INFO_END.${index}.DS_LOGRADOURO_ENDERECO`}
                                className="form-control"
                                placeholder="Rua"
                                defaultValue={
                                    props.ObjectInformacoesEndereco
                                        ?.DS_LOGRADOURO_ENDERECO
                                }
                                ref={register()}
                            />
                        </div>
                        <div className="input-icon input-icon-right p-2 col-12 col-sm-3">
                            <label
                                htmlFor={`INFO_END.${index}.NR_ENDERECO_ENDERECO`}
                            >
                                Nº
                            </label>
                            <input
                                type="text"
                                id={`INFO_END.${index}.NR_ENDERECO_ENDERECO`}
                                name={`INFO_END.${index}.NR_ENDERECO_ENDERECO`}
                                className="form-control"
                                placeholder="Nº"
                                defaultValue={
                                    props.ObjectInformacoesEndereco
                                        ?.NR_ENDERECO_ENDERECO
                                }
                                ref={register()}
                            />
                        </div>

                        <div className="input-icon input-icon-right p-2 col-12 col-sm-3">
                            <label
                                htmlFor={`INFO_END.${index}.DS_COMPLEMENTO_ENDERECO`}
                            >
                                Complemento
                            </label>
                            <input
                                type="text"
                                id={`INFO_END.${index}.DS_COMPLEMENTO_ENDERECO`}
                                name={`INFO_END.${index}.DS_COMPLEMENTO_ENDERECO`}
                                className="form-control"
                                placeholder="Nº"
                                defaultValue={
                                    props.ObjectInformacoesEndereco
                                        ?.DS_COMPLEMENTO_ENDERECO
                                }
                                ref={register()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
